import React, { useState, lazy, Suspense } from "react";
import "./TextArea.css";
import "../styles/theme/codemirror.css";
import "../styles/theme/monkeytype.css";
import "../styles/theme/lightmode.css";
import jsonlint from "jsonlint/lib/jsonlint";
import { validateJSON, validateJSONL } from "../utils/heplers";
import ThemeSwitcher from "./ThemeSwitcher";

// Lazy load Json component with all CodeMirror dependencies
const Json = lazy(() => import("./Json"));

window.jsonlint = jsonlint;
const TextArea = ({
  inputJSON,
  setInputJSON,
  jsonData,
  setJsonData,
  setTableFlag,
  tableFlag,
  showDataType,
  setShowDataType,
}) => {
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [autoValidate, setAutoValidate] = useState(false);
  const [spaceErrorMessage, setSpaceErrorMessage] = useState("");
  const [spaces, setSpaces] = useState(2);
  const [editorFontSize, setEditorFontSize] = useState(13);
  const [isCopied, setIsCopied] = useState(false);
  const [inputFormat, setInputFormat] = useState(null);

  const realTimeValidation = (value) => {
    if (!value) setErrorMessage("");
    else {
      const { valid: isValidJSON, message: validationJSONMessage } =
        validateJSON(value);
      const { valid: isValidJSONL, message: validationJSONLMessage } =
        validateJSONL(value);
      if (isValidJSON) {
        setErrorMessage("");
        setSuccessMessage(validationJSONMessage);
        setInputFormat("JSON");
      } else if (isValidJSONL) {
        setErrorMessage("");
        setSuccessMessage(validationJSONLMessage);
        setInputFormat("JSONL");
      } else {
        setErrorMessage(validationJSONLMessage);
        setSuccessMessage("");
        setInputFormat(null);
      }
    }
  };

  const handleClick = (e) => {
    e?.preventDefault();

    if (inputFormat === "JSONL") {
      try {
        setJsonData(
          JSON?.parse(
            "[".concat(inputJSON.trim().replace(/\n/g, ",")).concat("]")
          )
        );
      } catch ({ message }) {
        message
          ? setErrorMessage(`JSONL is invalid: ${message}`)
          : setErrorMessage("");
      }
    } else {
      try {
        const numberOfSpaces = parseInt(spaces);
        if (!numberOfSpaces) {
          setSpaces(2);
          setInputJSON(JSON?.stringify(JSON?.parse(inputJSON), null, 2));
        }
        setJsonData(JSON?.parse(inputJSON));
      } catch ({ message }) {
        message
          ? setErrorMessage(`JSON is invalid: ${message}`)
          : setErrorMessage("");
      }
    }
  };

  const copyTextFromTextArea = () => {
    navigator?.clipboard?.writeText(inputJSON);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 1500);
  };

  const toggleDataType = () => {
    setShowDataType(!showDataType);
  };

  const jsonComponentProps = {
    toggleDataType,
    copyTextFromTextArea,
    handleClick,
    realTimeValidation,
    spaces,
    setSpaces,
    editorFontSize,
    setEditorFontSize,
    errorMessage,
    setErrorMessage,
    inputJSON,
    setInputJSON,
    jsonData,
    setJsonData,
    setTableFlag,
    tableFlag,
    showDataType,
    setShowDataType,
    successMessage,
    setSuccessMessage,
    setIsCopied,
    isCopied,
    autoValidate,
    setAutoValidate,
    spaceErrorMessage,
    setSpaceErrorMessage,
    inputFormat,
    setInputFormat,
  };

  return (
    <>
      <nav className="navbar-compact">
        <div className="navbar-brand">
          TabularJSON by <a href="https://datumbrain.com/">Datum Brain</a>
        </div>
        <ThemeSwitcher />
      </nav>
      <div className="container">
        <Suspense fallback={
          <div className="editor-loading-placeholder">
            <p>Loading editor...</p>
          </div>
        }>
          <Json jsonComponentProps={jsonComponentProps} />
        </Suspense>
      </div>
    </>
  );
};
export default TextArea;
